import { add, contains, listen, qs, remove } from '@fluorescent/dom';

import { section } from '@/glow';

const classes = {
  hide: 'hide',
};

const selectors = {
  recoverPasswordLink: '#RecoverPassword',
  hideRecoverPasswordLink: '#HideRecoverPasswordLink',
  recoverPasswordForm: '#RecoverPasswordForm',
  loginForm: '#CustomerLoginForm',
  resetSuccessMessage: '#ResetSuccess',
  formState: '.reset-password-success',
};

section('login', {
  onLoad() {
    this.recoverPasswordForm = qs(
      selectors.recoverPasswordForm,
      this.container
    );
    this.loginForm = qs(selectors.loginForm, this.container);
    const recoverPasswordLink = qs(
      selectors.recoverPasswordLink,
      this.container
    );
    const hideRecoverPasswordLink = qs(
      selectors.hideRecoverPasswordLink,
      this.container
    );
    this.events = [];

    if (recoverPasswordLink) {
      this.checkUrlHash();
      this.resetPasswordSuccess();

      this.events.push(
        listen([recoverPasswordLink, hideRecoverPasswordLink], 'click', e => {
          e.preventDefault();

          this.toggleRecoverPasswordForm();
        })
      );
    }
  },

  checkUrlHash() {
    const hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      this.toggleRecoverPasswordForm();
    }
  },

  /**
   *  Show/Hide recover password form
   */
  toggleRecoverPasswordForm() {
    if (contains(this.recoverPasswordForm, classes.hide)) {
      remove(this.recoverPasswordForm, classes.hide);
      add(this.loginForm, classes.hide);
      this.recoverPasswordForm.setAttribute('aria-hidden', 'false');
      this.loginForm.setAttribute('aria-hidden', 'true');
    } else {
      remove(this.loginForm, classes.hide);
      add(this.recoverPasswordForm, classes.hide);
      this.recoverPasswordForm.setAttribute('aria-hidden', 'true');
      this.loginForm.setAttribute('aria-hidden', 'false');
    }
  },

  /**
   *  Show reset password success message
   */
  resetPasswordSuccess() {
    // check if reset password form was successfully submited.
    if (!qs(selectors.formState, this.container)) {
      return;
    }

    // show success message
    remove(qs(selectors.resetSuccessMessage, this.container), classes.hide);
  },
  onUnload() {
    this.events.forEach(unsubscribe => unsubscribe());
  },
});
